export default "__VITE_ASSET__CJeLUin3__"